import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { PostSessionPayloadDTO } from '../../dto';
import type { GetSessionOptions } from './get-session.types';

export function getSession(
  baseUrl: string,
  sessionId: NonNullable<PostSessionPayloadDTO['UserContext']['SessionId']>,
  options?: GetSessionOptions<PostSessionPayloadDTO>,
): Promise<IHttpResponse<PostSessionPayloadDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;

  const request: IHttpRequest<PostSessionPayloadDTO> = {
    url: `${baseUrl}/session/${sessionId}`,
    method: 'GET',
    ...options?.requestOverride,
    schemas: {
      response: PostSessionPayloadDTO,
    },
  };

  return call(request);
}
